import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TenantState } from './tenant.state';

export const selectTenantState = createFeatureSelector<TenantState>('tenant');

export const selectCurrentTenant = createSelector(
  selectTenantState,
  (state: TenantState) => state.currentTenant
);

export const selectTenantPlatformLanguage = createSelector(
  selectCurrentTenant,
  (tenant) => tenant?.platformLanguage ?? null
);

export const selectTenantLoading = createSelector(
  selectTenantState,
  (state: TenantState) => state.loading
);

export const selectTenantError = createSelector(
  selectTenantState,
  (state: TenantState) => state.error
);
